import VehicleTransactionHtml from './vehicle.transaction.html';

export const VehicleTransactionComponent : ng.IComponentOptions = {
  bindings: {
    onDelete: '&',
    onPrint : '&',
    vehicle : '<'
  },
  controller : 'VehicleTransactionCtrl',
  templateUrl: VehicleTransactionHtml
};
